var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("section", { staticClass: "menu" }, [
      _c("div", { staticClass: "page-inner" }, [
        _c(
          "ul",
          { staticClass: "column" },
          [
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: { to: { name: "index" } }
              },
              [_vm._v("首页")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: { to: { name: "index", query: { goAnchor: "inquiry" } } }
              },
              [_vm._v("询价")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: { to: { name: "index", query: { goAnchor: "inquiry" } } }
              },
              [_vm._v("发货")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "column" },
          [
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: { to: { name: "activitycenter" } }
              },
              [_vm._v("活动中心")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: {
                    name: "activitycenter",
                    query: { goAnchor: "activity" }
                  }
                }
              },
              [_vm._v("首单抽奖")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "column" },
          [
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: { to: { name: "productcenter" } }
              },
              [_vm._v("产品中心")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: { name: "productcenter", query: { goAnchor: "huozhu" } }
                }
              },
              [_vm._v("货主")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: { name: "productcenter", query: { goAnchor: "siji" } }
                }
              },
              [_vm._v("司机")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "column" },
          [
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: { to: { name: "recruitment" } }
              },
              [_vm._v("招贤纳士")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: { name: "recruitment", query: { goAnchor: "inquiry" } }
                }
              },
              [_vm._v("招聘")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "column" },
          [
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: { to: { name: "aboutus" } }
              },
              [_vm._v("关于我们")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: { name: "aboutus", query: { goAnchor: "jianjie" } }
                }
              },
              [_vm._v("公司简介")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: { name: "aboutus", query: { goAnchor: "licheng" } }
                }
              },
              [_vm._v("发展历程")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: { name: "aboutus", query: { goAnchor: "yuanjing" } }
                }
              },
              [_vm._v("企业文化")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                tag: "li",
                staticClass: "cell",
                attrs: {
                  to: { name: "aboutus", query: { goAnchor: "aboutus" } }
                }
              },
              [_vm._v("联系我们")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0)
      ])
    ]),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wechat-qrcode-wrapper" }, [
      _c("div", { staticClass: "icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "copyright" }, [
      _c("span", [
        _vm._v("©杭州享运物流 版权所有 "),
        _c(
          "a",
          {
            staticStyle: { color: "#FFF" },
            attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" }
          },
          [_vm._v("浙ICP备17007786号-2")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "300px", margin: "0 auto", padding: "0px 0" } },
        [
          _c(
            "a",
            {
              staticStyle: {
                display: "inline-block",
                "text-decoration": "none",
                height: "20px",
                "line-height": "20px"
              },
              attrs: { target: "_blank", href: " " }
            },
            [
              _c("img", {
                staticStyle: { float: "left" },
                attrs: { src: require("../assets/images/beian.png") }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    float: "left",
                    height: "20px",
                    "line-height": "20px",
                    margin: "0px 0px 0px 5px",
                    color: "#939393"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "text-decoration": "none",
                        height: "20px",
                        "line-height": "20px",
                        color: "#939393"
                      },
                      attrs: {
                        target: "_blank",
                        href:
                          "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014778"
                      }
                    },
                    [_vm._v("浙公网安备 33011002014778号")]
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6c4d8baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6c4d8baa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 